
export default {
  name: "QuizPagination",
  props: {
    stepsAmount: {
      type: Number,
      required: true,
    },
    activeStep: {
      type: Number,
      required: true,
    },
    quizResult: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onStepClick(step) {
      const enabled =
        step <= this.activeStep - 1 || this.quizResult[step - 1]?.value;
      if (!enabled) {
        return;
      }
      this.$emit("stepClick", step);
    },
  },
};
